import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionLabel } from './ui/SectionLabel';
import { CornerFrame } from './ui/CornerFrame';
import { Shield, Zap, Crosshair } from 'lucide-react';
export function Mechanism() {
  return <section className="py-14 md:py-16 bg-bio-dark relative overflow-hidden" data-id="element-192">
      {/* Background grid */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-193" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-194">
        <FadeIn data-id="element-195">
          <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-196">
            <div className="inline-block mb-3" data-id="element-197">
              <SectionLabel text="CORE MECHANISM // THE SOVEREIGN SHIELD" data-id="element-198" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-199">
              THE{' '}
              <span className="text-bio-teal text-glow-teal" data-id="element-200">
                SOVEREIGN SHIELD
              </span>{' '}
              FRAMEWORK
            </h2>
            <p className="text-xl text-bio-muted font-light" data-id="element-201">
              A synthesis of 3,000 years of Traditional Chinese Medicine (TCM)
              energetics and modern mitochondrial biohacking.
            </p>
          </div>
        </FadeIn>

        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto" data-id="element-202">
          <FadeIn delay={0.2} data-id="element-203">
            <CornerFrame className="bg-bio-black/80 backdrop-blur-sm" data-id="element-204">
              <div className="space-y-8" data-id="element-205">
                <div className="flex gap-6" data-id="element-206">
                  <div className="w-12 h-12 rounded-none bg-bio-teal/10 border border-bio-teal/30 flex items-center justify-center shrink-0" data-id="element-207">
                    <Zap className="w-6 h-6 text-bio-teal" data-id="element-208" />
                  </div>
                  <div data-id="element-209">
                    <h3 className="text-xl font-bold text-white mb-2 tracking-wide" data-id="element-210">
                      ENGINEER THE WEI QI
                    </h3>
                    <p className="text-bio-muted font-light" data-id="element-211">
                      Instead of just "taking supplements," we engineer the Wei
                      Qi (Defensive Energy) layer of your body.
                    </p>
                  </div>
                </div>

                <div className="flex gap-6" data-id="element-212">
                  <div className="w-12 h-12 rounded-none bg-bio-teal/10 border border-bio-teal/30 flex items-center justify-center shrink-0" data-id="element-213">
                    <Crosshair className="w-6 h-6 text-bio-teal" data-id="element-214" />
                  </div>
                  <div data-id="element-215">
                    <h3 className="text-xl font-bold text-white mb-2 tracking-wide" data-id="element-216">
                      INCREASE DETECTION VOLTAGE
                    </h3>
                    <p className="text-bio-muted font-light" data-id="element-217">
                      We don't just support your immune system; we increase its
                      "Detection Voltage."
                    </p>
                  </div>
                </div>

                <div className="flex gap-6" data-id="element-218">
                  <div className="w-12 h-12 rounded-none bg-bio-teal/10 border border-bio-teal/30 flex items-center justify-center shrink-0" data-id="element-219">
                    <Shield className="w-6 h-6 text-bio-teal" data-id="element-220" />
                  </div>
                  <div data-id="element-221">
                    <h3 className="text-xl font-bold text-white mb-2 tracking-wide" data-id="element-222">
                      HARDEN THE GATES
                    </h3>
                    <p className="text-bio-muted font-light" data-id="element-223">
                      By optimizing cellular energy and hardening your
                      respiratory and digestive "gates," we make your body an
                      inhospitable environment for invaders.
                    </p>
                  </div>
                </div>
              </div>
            </CornerFrame>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-224">
            <div className="relative aspect-square max-w-md mx-auto flex items-center justify-center" data-id="element-225">
              {/* Abstract tech-shield visualization */}
              <div className="absolute inset-0 border border-bio-teal/20 rounded-full animate-[spin_20s_linear_infinite]" data-id="element-226" />
              <div className="absolute inset-4 border border-dashed border-bio-teal/30 rounded-full animate-[spin_15s_linear_infinite_reverse]" data-id="element-227" />
              <div className="absolute inset-12 border border-bio-teal/10 rounded-full bg-bio-teal/5 backdrop-blur-md" data-id="element-228" />

              <div className="relative z-10 text-center" data-id="element-229">
                <Shield className="w-24 h-24 text-bio-teal mx-auto mb-4 drop-shadow-[0_0_15px_rgba(45,212,191,0.5)]" data-id="element-230" />
                <div className="font-mono text-bio-teal text-sm tracking-widest" data-id="element-231">
                  STATUS: <span className="text-white" data-id="element-232">FORTRESS ACTIVE</span>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}